
export { default as compose } from "./compose.js"
export { default as find } from "./find.js"
export { default as pathOr } from "./pathOr.js"
export { default as propEq } from "./propEq.js"
export { default as propOr } from "./propOr.js"